import { createSelector } from "reselect";

const _byId = (state) =>
  state.promotionProgress ? state.promotionProgress.byId : {};

export const getPromotionProgressById = createSelector(
  _byId,
  (_, id) => id,
  (byId, id) => byId[id] || null,
);
